namespace $.$$ {

	$mol_style_define( $shm_wordstat_table, {
		flex: {
			grow: 1,
		},
		minHeight: 0,
		Grid: {
			flex: {
				grow: 1,
			},
		},
		Cell: {
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
		},
		Col_head: {
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
		},
		Cell_link: {
			margin: {
				top: '-0.75rem',
				bottom: '-0.75rem',
				left: '-0.5rem',
				right: '-0.5rem',
			},
		},
	} )

}
